import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useConfig } from '../context/config'

export const useWhatsappSupport = () => {
  const { config } = useConfig()
  const { t } = useTranslation()

  const whatsappPhone = config.partnerConfig.supportProvider.info?.whatsapp

  const whatsappUrl = useMemo(() => (whatsappPhone ? `https://wa.me/${whatsappPhone}` : undefined), [whatsappPhone])

  const whatsappUrlWithIntro = useMemo(() => {
    if (!whatsappUrl) {
      return undefined
    }

    const introText = t('screens.welcome.registrationOrientation.whatsappSupportIntro')
    const textSlug = introText ? `?text=${introText}` : ''

    return `${whatsappUrl}${textSlug}`
  }, [whatsappUrl, t])

  return { whatsappUrlWithIntro, whatsappUrl }
}
